import { createLogger } from 'copyright-clearance-center-common-ui-react';

// We are not ready to send logs on the back-end
export default createLogger('rfe-logger', { ajaxLogger: false, consoleLogger: false });
